module.exports = __webpack_public_path__ + "img/img_project_content4.58ec373c.svg";